import {
  ActionIcon,
  Box,
  Button,
  Center,
  createStyles,
  Menu,
  Text,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import "./index.css";
import {  useNavigate } from "react-router-dom";
import BilingDrawer from "./billingdrawer";


import { getpayer } from "../../services/payer";
import { getServicecode } from "../../services/servicecode";
import { getBillingProvider } from "../../services/billingprovider";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { getBillingCard } from "../../services";
import { updateProfile } from "../../services/profile";
import { FaS } from "react-icons/fa6";

const useStyles = createStyles(() => ({
  drawer: {
    ".mantine-Drawer-content": {
      backgroundColor: "#f5f5f5",
    },
  },

  mainContainer: {
    background: "#f5f5f5",
    display: "flex",
    borderRadius: "20px",
    border: "1px solid #E5E5E5",
    backgroundColor: "#FFF",
    width: "100%",
    margin: "auto",
    marginTop: "20px",
    "@media (max-width:800px)": {
      width: "90%",
    },
    "@media (max-width:500px)": {
      width: "100%",
    },
    // justify-content: center'
    // align-items: center;

    // margin-top: 20px;
  },

  searchbox: {
    // marginTop: "50px",
    // marginBottom: "50px",
    width: "100% !important",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  tabs: {
    width: "100%",
    // marginTop: "40px",
    marginBottom: "50px",
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "12px",
    // padding: "27px 16px",
    background: "#F5F5F5",
    "@media (max-width:1200px)": {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
  },

  displaybox: {
    display: "flex",
    gap: "20px",
    "@media (max-width:1200px)": {
      display: "flex",
      flexDirection: "column",
    },
  },

  tabbtn: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "20px",
  },

  tabsinner: {
    // width: "15%",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    background: "#F9FAFB",
    padding: "12px 20px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textAlign: "center",
    cursor: "pointer",
  },

  mainbillingbox: {
    width: "100%",
    // margin: auto;
    // display: flex;
    // flex-direction: column;

    // align-items: center;
  },

  mainbillingcontainer: {
    background: "#F5F5F5",
    // display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "fit-content",
    padding: "14px 28px 14px 20px",

    "@media (max-width:900px)": {
      paddingRight: "10px",
      paddingLeft: "10px",
    },
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between",
    gap: "24px",
    "@media (max-width:1300px)": {
      gap: "10px",
    },
  },

  container: {
    margin: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
  },
  userDetails: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteDetails: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  noteContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: ".5rem",
  },
  item: {
    // border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
  },
  outcomeBox: {
    display: "flex",
    gap: "1rem",
    backgroundColor: "#FAFAFA",
    padding: "1rem",
    borderRadius: "10px",
    border: "1px solid #E7EBEF",
    marginBottom: "1rem",
    marginTop: "1rem",
  },
  coutcomeItem: {
    display: "flex",
    gap: ".4rem",
    flex: "1",
    flexDirection: "column",
  },
  outcomeNote: {
    backgroundColor: "#FAFAFA",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5E5",
    borderWidth: "2px",
    borderStyle: "solid",
    marginTop: "1rem",
  },

  // img:{
  //   position: "relative",
  //   top:"10px",
  // },
  btns: {
    display: "flex",
    gap: "1rem",
    // justifyContent: "space-between",
    justifyContent: "flex-end",
    gap: "4px",
    marginTop: "12rem",
  },

  backbtn: {
    borderRadius: "8px",
    border: "1px solid #F5F5F5",
    background: "#F5F5F5",

    /* Shadow/xs */
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },

  mainbox: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "50%",
    margin: "auto",
    "@media (max-width:1100px)": {
      width: "85%",
    },
  },

  text: {
    marginTop: "5px",
    marginLeft: "-21px",
    "@media (max-width:500px)": {
      fontSize: "14px",
    },
  },

  beginbilling: {
    textAlign: "center",
    alignItems: "center",
    marginTop: "22px",
    marginBottom: "22px",
    cursor: "pointer",
  },

  mt: {
    marginTop: "20px",
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  box: {
    width: "30px",
    height: "30px",
    border: "1px solid #000",
    background: "#D9D9D9",
    color: "#FFF",
  },

  cp: {
    cursor: "pointer",
  },

  btnflex: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },

  addbtn: {
    marginTop: "44px",
    marginBottom: "4px",
    display: "flex",
    justifyContent: "flex-end",
  },
  stepNumberText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  checkbox: {
    width: "20px",
    height: "20px",
    // borderRadius: "6px",
    // border: "1px solid  #D0D5DD",
    // background: "#FFF",
    marginRight: "10px",
  },

  selectbox: {
    width: "100%",
    padding: "37px 365px 0px 365px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    borderRadius: "12px",
    // background: "#FFF",
    height: "73px",
  },

  header: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "400",
    color: "#737373",
  },

  row: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "800",
    color: "#262626",
  },
}));

function CreateClaim({ setCheckEligibility }) {
  const navigate = useNavigate();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [claimData, setClaimData] = useState({ claimId: "", claimType: "" });
  const [patientsdata, setPatientsdata] = useState([]);
  const [state, setState] = useState(false);
  const [agree, setAgree] = useState(true);
  const { classes } = useStyles();
  const [settingdrawerOpened, setSettingDrawerOpened] = useState(false);
  const [hoveredProfessional, setHoveredProfessional] = useState(false);
  const [hoveredInstitutional, setHoveredInstitutional] = useState(false);
  const [hoveredEligibility, setHoveredEligibility] = useState(false);
  const { profile } = useSelector((state) => state?.profile);



  // const closeSettingDrawer = () => setSettingDrawerOpened(false);

  // const openDrawer = () => setDrawerOpened(true);
  // const openDrawer = (claimType) => {
  //   const claimId = claimType === "professional" ? "837p" : "837i";
  //   setClaimData({ claimId, claimType });
  //   setDrawerOpened(true);
  // };

  const { billingcard } = useSelector((state) => state.billing);


  const handleProfessionalClaimClick = async () => {
    setCheckEligibility(false);
    if (!profile?.admin?.billingAgree) {
      setClaimData({
        claimId: "837p",
        claimType: "professional",
      });

      navigate("/home/billing-claim-form", {
        state: {
          makepair: true,
          claimData: {
            claimId: "837p",
            claimType: "professional",
          },
        },
      });
    } else if (billingcard && billingcard?.BillingPayment === null) {
      await swal({
        title: "Card not Connected",
        text: `Please connect a bank or credit card account to start a claim.`,
        dangerMode: true,
      });

      return HandleNavigatepair("payment");
    } else {
      setClaimData({
        claimId: "837p",
        claimType: "professional",
      });

      navigate("/home/billing-claim-form", {
        state: {
          makepair: true,
          claimData: {
            claimId: "837p",
            claimType: "professional",
          },
        },
      });
    }
  };

  const hoverBackgroundColor = "#FF9A00";

  const handleInstitutionalClaimClick = async () => {
    setCheckEligibility(false);
    if (!profile?.admin?.billingAgree) {
      setClaimData({
        claimId: "837i",
        claimType: "institutional",
      });

      navigate("/home/billing-claim-form", {
        state: {
          makepair: true,
          claimData: {
            claimId: "837i",
            claimType: "institutional",
          },
        },
      });
    } else if (billingcard && billingcard?.BillingPayment === null) {
      await swal({
        title: "Card not Connected",
        text: `Please connect a bank or credit card account to start a claim.`,
        dangerMode: true,
      });

      return HandleNavigatepair("payment");
    } else {
      setClaimData({
        claimId: "837i",
        claimType: "institutional",
      });
      navigate("/home/billing-claim-form", {
        state: {
          makepair: true,
          claimData: {
            claimId: "837i",
            claimType: "institutional",
          },
        },
      });
    }
  };

  useEffect(() => {
    let payload = {
      page: 1,
    };

    getpayer(payload);
    getServicecode();
    getBillingProvider(payload);
    getBillingCard();
    // getAllPatientsModal();
    // getAllPatientsModal()
  }, []);

  // const location = useLocation();
  // console.log('location',location);

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const claimId = queryParams.get("claimId");
  //   const claimType = queryParams.get("claimType");

  //   if (claimId && claimType) {
  //     setClaimData({ claimId, claimType });
  //   }
  // }, [location.search]);

  // useEffect(() => {
  //   const fetchPatients = async () => {
  //     const patientsData = await getAllPatientsModal();
  //     if (patientsData) {
  //       setPatientsdata(patientsData);
  //     }
  //   };

  //   fetchPatients();
  // }, []);

  // console.log("patientsdata", patientsdata);

  const closeDrawer = () => setDrawerOpened(false);
  // let agree=true;
  let professionalBackgroundColor =
    claimData.claimType === "professional" ? "#FFAF4A" : "#FFAF4A";
  let institutionalBackgroundColor =
    claimData.claimType === "institutional" ? "#FFAF4A" : "#FFAF4A";
  let eligbilitycheck = state ? "#FFAF4A" : "#FFAF4A";

  let settingtrue = settingdrawerOpened ? "#FFAF4A" : "#F9FAFB";

  const HandleNavigatepair = (item) => {
    navigate("/home/billing-claim-form", {
      state: {
        manage: item,
      },
    });
  };

  const EligibilityCheck = async () => {
    if (profile?.user?.billingEligibilityAgree) {
      if (billingcard && billingcard?.BillingPayment === null) {
        await swal({
          title: "Card not Connected",
          text: `Please connect a bank or credit card account to start a claim.`,
          dangerMode: true,
        });
        return HandleNavigatepair("payment");
      } else {
        setState(true);
        setCheckEligibility(true);
        setClaimData({
          claimId: "",
          claimType: "",
        });
      }
    } else {
      const willDelete = await swal({
        title: `Do you wish to continue?`,
        text: "Running an eligibility verification will incur a non-refundable $0.50 fee per request. This charge will be automatically included in your next month’s Ogiso Billing cycle.",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Yes, Proceed"],
      });

      if (willDelete) {
        setState(true);
        setCheckEligibility(true);
        setClaimData({
          claimId: "",
          claimType: "",
        });

        try {
          let payload = {
            ...profile,
            billingEligibilityAgree: true,
          };

          console.log("payload", payload);

          let response = await updateProfile(payload);

          console.log("response", response);

          if (response?.status === 200) {
            if (billingcard && billingcard?.BillingPayment === null) {
              await swal({
                title: "Card not Connected",
                text: `Please connect a bank or credit card account to start a claim.`,
                dangerMode: true,
              });
              return HandleNavigatepair("payment");
            } else {
              setState(true);
              setCheckEligibility(true);
              setClaimData({
                claimId: "",
                claimType: "",
              });
            }
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    }
  };

  // console.log('professionalBackgroundColor',professionalBackgroundColor);
  // console.log('institutionalBackgroundColor',institutionalBackgroundColor);

  return (
    <>
      <div className="claimmain">
        <div className={classes.mainbillingcontainer}>
          <Text
            style={{ marginBottom: "15px" }}
            ff="Inter"
            fz={32}
            fw={200}
            color="#000"
          >
            Select a claim type below
          </Text>
          <Box className={classes.tabs}>
            <Box className={classes.displaybox}>
              <Box
                style={{
                  // backgroundColor: hoveredProfessional
                  //   ? hoverBackgroundColor
                  //   : professionalBackgroundColor,
                  // transition: "background-color 0.3s ease",
                  backgroundColor: professionalBackgroundColor,
                }}
                onClick={handleProfessionalClaimClick}
                onMouseEnter={() => setHoveredProfessional(true)}
                onMouseLeave={() => setHoveredProfessional(false)}
                className={classes.tabsinner}
              >
                <Text ff="Inter" fz={16} fw={600} color="#262626">
                  Start Professional Claim
                </Text>
              </Box>
              {/* <Box
                // style={{ backgroundColor: institutionalBackgroundColor }}
                style={{
                  // backgroundColor: hoveredInstitutional
                  //   ? hoverBackgroundColor
                  //   : institutionalBackgroundColor,
                  // transition: "background-color 0.3s ease", // Smooth transition
                  // cursor:'not-allowed',
                  backgroundColor: institutionalBackgroundColor,
                }}
                // onMouseEnter={() => setHoveredInstitutional(true)}
                // onMouseLeave={() => setHoveredInstitutional(false)}
                onClick={handleInstitutionalClaimClick}
                className={classes.tabsinner}
              >
                <Text ff="Inter" fz={16} fw={600} color="#262626">
                  Start Institutional Claim
                </Text>
              </Box> */}
              <Box
                // style={{ backgroundColor: eligbilitycheck }}
                style={{
                  // backgroundColor: hoveredEligibility
                  //   ? hoverBackgroundColor
                  //   : eligbilitycheck,
                  // transition: "background-color 0.3s ease", // Smooth transition
                  backgroundColor: eligbilitycheck,
                }}
                onMouseEnter={() => setHoveredEligibility(true)}
                onMouseLeave={() => setHoveredEligibility(false)}
                onClick={EligibilityCheck}
                // onClick={() => {
                //   setState(true);
                //   setCheckEligibility(true)
                //   setClaimData({
                //     claimId: "",
                //     claimType: "",
                //   });
                // }}
                className={classes.tabsinner}
              >
                <Text ff="Inter" fz={16} fw={600} color="#262626">
                  Verify Eligibility
                </Text>
              </Box>
            </Box>

  

       
            <Box
              // style={{ backgroundColor: settingtrue }}
              className={classes.tabsinner}
            >
              <Menu shadow="md" width={177}>
                <Menu.Target>
                  <Box
                    onClick={() => {
                      setSettingDrawerOpened(true);

                      setState(false);
                      setClaimData({
                        claimId: "",
                        claimType: "",
                      });
                    }}
                    style={{
                      display: "flex",
                      gap: "20px",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      // className="img"
                      width={24}
                      height={24}
                      src="/assets/images/component.png"
                      alt="home"
                    />
                    <Text ff="Inter" fz={16} fw={600} color="#262626">
                      Settings
                    </Text>
                  </Box>
                </Menu.Target>

                <Menu.Dropdown pos={"bottom-start"} top={"261px"}>
                  <Menu.Item
                    ff="Inter"
                    fz={14}
                    fw={600}
                    color="#262626"
                    //  onClick={HandleNavigatepair}
                    onClick={() => {
                      HandleNavigatepair("provider");
                    }}

                    // onClick={() => handleEditProvider({ id: 1 }, true)}
                  >
                    Manage Provider
                    <Text ff="Inter" fz={10} fw={400} color="#737373">
                      Revisit key details
                    </Text>
                  </Menu.Item>
                  <Menu.Item
                    ff="Inter"
                    fz={14}
                    fw={600}
                    color="#262626"
                    onClick={() => {
                      HandleNavigatepair("client");
                    }}

                    // onClick={() => handleEditProvider({ id: 1 }, false)}
                  >
                    Manage Client
                    <Text ff="Inter" fz={10} fw={400} color="#737373">
                      Revisit key details
                    </Text>
                  </Menu.Item>
                  <Menu.Item
                    ff="Inter"
                    fz={14}
                    fw={600}
                    color="#262626"
                    onClick={() => {
                      HandleNavigatepair("payer");
                    }}
                  >
                    Manage Payer
                    <Text ff="Inter" fz={10} fw={400} color="#737373">
                      Revisit key details
                    </Text>
                  </Menu.Item>

                  {!profile?.user?.role
                  
                  ?
                  <>
                      <Menu.Item
                    ff="Inter"
                    fz={14}
                    fw={600}
                    color="#262626"
                    onClick={() => {
                      HandleNavigatepair("payment");
                    }}
                  >
                    Manage Payments
                    <Text ff="Inter" fz={10} fw={400} color="#737373">
                      Revisit key details
                    </Text>
                  </Menu.Item>

                  </>



                  : null }
              
                </Menu.Dropdown>
              </Menu>
         
            </Box>
          </Box>
        </div>

        {!agree ? (
          <div className="maincontainer">
            <div className="mainbillingbox">
              <img src="/assets/images/billingimg.png" alt="Icon" />

              <h1 className="terms">Terms and Agreement</h1>

              <p className="termspara">
                By signing up for Ogiso’s billing services you agree to our
                billing terms and agreement. Ogiso charges a 2% to 3% fee of the
                total billing amount.
              </p>

              <Button
                color="yellow"
                className="signupbillingbtn"
                padding={11}
                onClick={() => {
                  setAgree(false);
                }}
              >
                Signup for Billing
              </Button>
            </div>
          </div>
        ) : null}
      </div>

      <Center>
        <BilingDrawer
          // title="Select Provider"
          opened={drawerOpened}
          close={closeDrawer}
          claimData={claimData}
          patientsdata={patientsdata}
        />
      </Center>

      {/* <Center>
        <SettingDrawer
          title="Settings"
          opened={settingdrawerOpened}
          close={closeSettingDrawer}
          // claimData={claimData}
          // patientsdata={patientsdata}
        />
      </Center> */}
    </>
  );
}

export default CreateClaim;
